// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto; /* Allow scrolling when modal is not open */
}


.history-menu-modal-overlay {
    position: fixed;
    inset: 0;  /* Cover the entire screen */
    padding: env(safe-area-inset-top) env(safe-area-inset-right) 
             env(safe-area-inset-bottom) env(safe-area-inset-left);
    background-color: rgba(0, 0, 0, 0.185);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.3s ease; /* Smooth transition */
}

.history-menu-modal {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    width: 100%;
    max-width: 500px;
    max-height: 90vh;
    padding: 50px 32px 32px 32px;
    border-radius: 20px;
    box-sizing: border-box;
    overflow: hidden; /* remove scroll here */
}


.history-input-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
}


.history-close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    color: #333 !important;
    font-size: 35px !important;
    font-weight: lighter;
    cursor: pointer;
    padding: 8px;
    z-index: 10;
    transition: color 0.3s;
}


.history-close-button:hover {
    color: #666!important;
}

.fade-in {
    opacity: 1;
}

.fade-out {
    opacity: 0;
    pointer-events: none; /* Prevent clicks during fade-out */
}

.quote-history-list {
    margin: 0px;
    padding: 0px;
}

.quote-history-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    font-size: 16px;
    width: 100%;
}

.delete-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    transition: color 0.2s, background-color 0.2s;
}

.delete-button:hover {
    color: #d63031;
}

.delete-icon {
    display: block;
}

.timestamp {
    font-size: 0.8em;
    color: #888;
    margin-left: 8px;
}



.styled-calculation-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-height: calc(100% - 200px)!important;
  box-sizing: border-box;
}

.styled-card {
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.card-header {
  background-color: #6294AA;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.calculation-name {
  font-weight: 600;
  font-size: 16px;
}

.card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  text-decoration: none;
  color: #333;
}

.card-body:hover {
  background-color: #f8f9fa;
}

.date-text {
  font-size: 14px;
  color: #555;
}

.uvalue-row {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.uvalue-label {
  font-size: 12px;
  font-weight: normal;
  margin-left: 4px;
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/HistoryModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB,EAAE,2CAA2C;AACjE;;;AAGA;IACI,eAAe;IACf,QAAQ,GAAG,4BAA4B;IACvC;kEAC8D;IAC9D,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,6BAA6B,EAAE,sBAAsB;AACzD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB,EAAE,uBAAuB;AAC7C;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB,EAAE,mCAAmC;AAC7D;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;;;AAIA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["html, body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow-y: auto; /* Allow scrolling when modal is not open */\n}\n\n\n.history-menu-modal-overlay {\n    position: fixed;\n    inset: 0;  /* Cover the entire screen */\n    padding: env(safe-area-inset-top) env(safe-area-inset-right) \n             env(safe-area-inset-bottom) env(safe-area-inset-left);\n    background-color: rgba(0, 0, 0, 0.185);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    opacity: 0;\n    overflow: hidden;\n    transition: opacity 0.3s ease; /* Smooth transition */\n}\n\n.history-menu-modal {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(255, 255, 255);\n    width: 100%;\n    max-width: 500px;\n    max-height: 90vh;\n    padding: 50px 32px 32px 32px;\n    border-radius: 20px;\n    box-sizing: border-box;\n    overflow: hidden; /* remove scroll here */\n}\n\n\n.history-input-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: scroll;\n}\n\n\n.history-close-button {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    background: none;\n    border: none;\n    color: #333 !important;\n    font-size: 35px !important;\n    font-weight: lighter;\n    cursor: pointer;\n    padding: 8px;\n    z-index: 10;\n    transition: color 0.3s;\n}\n\n\n.history-close-button:hover {\n    color: #666!important;\n}\n\n.fade-in {\n    opacity: 1;\n}\n\n.fade-out {\n    opacity: 0;\n    pointer-events: none; /* Prevent clicks during fade-out */\n}\n\n.quote-history-list {\n    margin: 0px;\n    padding: 0px;\n}\n\n.quote-history-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0;\n    font-size: 16px;\n    width: 100%;\n}\n\n.delete-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    transition: color 0.2s, background-color 0.2s;\n}\n\n.delete-button:hover {\n    color: #d63031;\n}\n\n.delete-icon {\n    display: block;\n}\n\n.timestamp {\n    font-size: 0.8em;\n    color: #888;\n    margin-left: 8px;\n}\n\n\n\n.styled-calculation-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  max-height: calc(100% - 200px)!important;\n  box-sizing: border-box;\n}\n\n.styled-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.card-header {\n  background-color: #6294AA;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n}\n\n.calculation-name {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.card-body {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: #333;\n}\n\n.card-body:hover {\n  background-color: #f8f9fa;\n}\n\n.date-text {\n  font-size: 14px;\n  color: #555;\n}\n\n.uvalue-row {\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n}\n\n.uvalue-label {\n  font-size: 12px;\n  font-weight: normal;\n  margin-left: 4px;\n  color: #777;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
